var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFmsMonitoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1tpp2gyp9a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15404",
    transform: "translate(306 2738)",
    style: {
      fill: "#ff2e2e",
      opacity: 0.158
    },
    d: "M0 0h180v180H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "monitoring_icon",
    transform: "translate(-306 -2738)",
    style: {
      clipPath: "url(#1tpp2gyp9a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 701",
    transform: "translate(23.289 464.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15403",
    width: 135,
    height: 97.644,
    rx: 6,
    transform: "translate(305 2306)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 103",
    transform: "translate(366.06 2403.643)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0v17.152"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 104",
    transform: "translate(378.94 2403.643)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0v17.152"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 105",
    transform: "translate(344.788 2421.847)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h55.422"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 106",
    transform: "translate(305 2384.116)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h135"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 107",
    transform: "translate(366.06 2403.643)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0v17.152"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 108",
    transform: "translate(378.94 2403.643)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0v17.152"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 109",
    transform: "translate(344.788 2421.847)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h55.422"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 110",
    transform: "translate(305 2384.116)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h135"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59585",
    d: "M59.346 71.429a3.272 3.272 0 1 1-4.527-.962 3.272 3.272 0 0 1 4.527.962",
    transform: "translate(315.893 2320.668)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59586",
    d: "M1 11h81.932l6.7 6.7h45.939",
    transform: "translate(304 2307.273)",
    style: {
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59587",
    d: "M82.455 7A2.455 2.455 0 1 1 80 9.455 2.454 2.454 0 0 1 82.455 7",
    transform: "translate(321.955 2306.364)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59588",
    d: "M91.455 7A2.455 2.455 0 1 1 89 9.455 2.454 2.454 0 0 1 91.455 7",
    transform: "translate(324 2306.364)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59589",
    d: "M100.455 7A2.455 2.455 0 1 1 98 9.455 2.454 2.454 0 0 1 100.455 7",
    transform: "translate(326.045 2306.364)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 712",
    transform: "translate(334.785 2334.972)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "\\uD0C0\\uC6D0 98",
    cx: 13.643,
    cy: 14.427,
    rx: 13.643,
    ry: 14.427,
    transform: "translate(0 6.258)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59590",
    d: "M20.7 36.526a9.087 9.087 0 0 1 6.405-4.94",
    transform: "translate(-15.522 -21.011)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59591",
    d: "M72.363 36.526a9.087 9.087 0 0 1 6.405-4.94",
    transform: "translate(-19.565 -21.011)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "\\uD0C0\\uC6D0 99",
    cx: 13.643,
    cy: 14.427,
    rx: 13.643,
    ry: 14.427,
    transform: "translate(48.145 6.258)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59592",
    d: "m44.372 44.722 5.49-3.254a9.528 9.528 0 0 1 9.857.047l5.8 3.51",
    transform: "translate(-17.375 -21.226)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59593",
    d: "M60.034 24.189a13.961 13.961 0 0 1 3.01 1.369l8.356 5.054",
    transform: "translate(-18.601 -20.823)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59594",
    d: "m39.324 30.172 7.906-4.686a13.981 13.981 0 0 1 3.459-1.466",
    transform: "translate(-16.98 -20.82)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59595",
    d: "M59.377 24.821a3.868 3.868 0 1 1-3.862-4.084 3.978 3.978 0 0 1 3.862 4.084z",
    transform: "translate(-17.945 -20.737)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFmsMonitoring);
export default __webpack_public_path__ + "static/media/ico_fms_monitoring.60447ff84b382366c07726de63c004d5.svg";
export { ForwardRef as ReactComponent };